// API client de la galería de imágenes generadas.
// Backend: mcp_django/apps/multimedia — /admin/multimedia/gallery.
// Toda imagen que el sistema genera para la org (heros, campañas, social)
// queda registrada aquí; esta vista es donde el equipo la reencuentra.

import { ensureFreshToken } from '@/lib/tokenRefresh';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/multimedia/gallery';

export interface GalleryImage {
  id: number;
  url: string;
  prompt: string;
  source: string;
  used_in: string;
  favorite: boolean;
  created_at: string | null;
}

export interface GalleryPage {
  count: number;
  total: number;
  items: GalleryImage[];
}

async function authHeaders(): Promise<Record<string, string>> {
  await ensureFreshToken();
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  return res.json() as Promise<T>;
}

export async function listGallery(params: {
  source?: string;
  favorites?: boolean;
  q?: string;
  limit?: number;
  offset?: number;
} = {}): Promise<GalleryPage> {
  const qs = new URLSearchParams();
  if (params.source) qs.set('source', params.source);
  if (params.favorites) qs.set('favorites', 'true');
  if (params.q) qs.set('q', params.q);
  qs.set('limit', String(params.limit ?? 40));
  if (params.offset) qs.set('offset', String(params.offset));
  const res = await fetch(`${DJANGO_PROXY}${BASE}/?${qs.toString()}`, {
    headers: await authHeaders(),
  });
  return asJson<GalleryPage>(res);
}

export async function updateGalleryImage(
  id: number,
  patch: { favorite?: boolean; archived?: boolean },
): Promise<{ id: number; favorite: boolean; archived: boolean }> {
  const qs = new URLSearchParams();
  if (patch.favorite !== undefined) qs.set('favorite', String(patch.favorite));
  if (patch.archived !== undefined) qs.set('archived', String(patch.archived));
  const res = await fetch(`${DJANGO_PROXY}${BASE}/${id}?${qs.toString()}`, {
    method: 'PATCH',
    headers: await authHeaders(),
  });
  return asJson(res);
}

// Etiquetas legibles por origen (el backend guarda el enum crudo).
export const SOURCE_LABELS: Record<string, string> = {
  campaign: 'Campaña',
  landing_hero: 'Hero de landing',
  social: 'Social',
  ai_images: 'Generador',
  other: 'Otro',
};
